/* eslint-disable no-underscore-dangle */
import React from 'react'
import { ICellRendererParams } from 'ag-grid-enterprise'
import { Button } from 'antd'
import { Sigma } from 'lucide-react'
import { EnhancedStatementRow } from '../../../../utils/dataEnhancement'
import { DualValueCell } from '../DualValueCell'
import { shouldUseDualValueDisplay } from '../../../../utils/columnUtils'
import { FlexCellContent, TruncatableText, NoShrinkContainer } from '../CellComponents'
import { BudgetMethodButton } from './BudgetMethodButton'

export const DimensionNameCellRenderer: React.FC<ICellRendererParams<EnhancedStatementRow>> = params => {
  const { data, context } = params
  const dimensionName = data?.dimensionName

  const showBudgetButton = context?.isEditMode && data?._sourceAccountCode

  // Use dual value display only when in edit mode for budgetable dimensions
  if (shouldUseDualValueDisplay(params) && context?.isEditMode) {
    return (
      <FlexCellContent>
        <TruncatableText>{dimensionName}</TruncatableText>
        <NoShrinkContainer>
          <DualValueCell
            calculatedContent={
              <Button icon={<Sigma style={{ width: 16, height: 16 }} />} type="text" size="small" disabled />
            }
            inputContent={<BudgetMethodButton data={data} style={{ height: '20px', marginLeft: '0px' }} />}
            style={{ justifyContent: 'space-between' }}
          />
        </NoShrinkContainer>
      </FlexCellContent>
    )
  }

  // Normal render with optional budget button
  return (
    <FlexCellContent>
      <TruncatableText>{dimensionName}</TruncatableText>
      {showBudgetButton && (
        <NoShrinkContainer>
          <BudgetMethodButton data={data} style={{ height: '20px', marginLeft: '4px' }} />
        </NoShrinkContainer>
      )}
    </FlexCellContent>
  )
}
